<template>
  <v-app>
    <v-toolbar app class="app-toolbar">
      <v-btn :ripple="false" icon @click="$router.go(-1)">
        <v-icon class="icon-light">arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>Coronavirus</v-toolbar-title>
    </v-toolbar>
    <v-content pa-0>
      <v-container fluid fill-height style="flex-direction: column; ">
        <v-layout row wrap justify-center xs12 style="width: 100%; flex-grow: 0; height: auto">
          <v-flex pb-2 xs12 md4 style="padding:0 0.5em 0.5em 0">
            <v-card color="primary" class="white--text">
              <v-card-title primary-title>
                <div class="headline" style="text-align: center; display: block; width: 100%">{{
                  formatNumber(data.top["Coronavirus Cases"])}}
                </div>
                <div style="text-align: center; display: block; width: 100%">Caronavirus Cases</div>
                <div style="display: flex; width: 100%; padding-top: 2em">
                  <div style="flex-grow: 1">
                    <div class="headline" style="text-align: center; display: block; width: 100%">{{
                      formatNumber(data.top["Deaths"])}}
                    </div>
                    <div style="text-align: center; display: block; width: 100%">Deaths</div>
                  </div>
                  <div style="flex-grow: 1">
                    <div class="headline" style="text-align: center; display: block; width: 100%">{{
                      formatNumber(data.top["Recovered"])}}
                    </div>
                    <div style="text-align: center; display: block; width: 100%">Recovered</div>
                  </div>
                </div>
              </v-card-title>
              <v-card-actions style="text-align: center; display: block">
                <v-btn flat dark @click="$router.push({name: 'authenticated.coronavirus.countries'})">
                  View By Country
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <!--        <v-layout row wrap justify-center xs12 style="width: 100%; flex-grow: 0; height: auto" v-if="stats !== null">-->
        <!--          <v-flex xs6 md2 style="padding:0 0.5em 0.5em 0">-->
        <!--            <v-card color="success" class="white&#45;&#45;text">-->
        <!--              <v-card-title primary-title>-->
        <!--                <div class="headline" style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[0].value }}-->
        <!--                </div>-->
        <!--                <div style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[0].name }}-->
        <!--                </div>-->
        <!--                <div class="headline" style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[0].value }}-->
        <!--                </div>-->
        <!--                <div style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[0].name }}-->
        <!--                </div>-->
        <!--              </v-card-title>-->
        <!--            </v-card>-->
        <!--          </v-flex>-->
        <!--          <v-flex xs6 md2 style="padding: 0 0 0.5em 0.5em">-->
        <!--            <v-card color="#ad3335" class="white&#45;&#45;text">-->
        <!--              <v-card-title primary-title>-->
        <!--                <div class="headline" style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[1].value }}-->
        <!--                </div>-->
        <!--                <div  style="text-align: center; display: block; width: 100%">-->
        <!--                  {{ data.stats[1].name }}-->
        <!--                </div>-->

        <!--              </v-card-title>-->
        <!--            </v-card>-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
        <v-layout justify-center style="width: 100%; flex-grow: 0; height: auto" v-if="articles != null">
          <v-expansion-panel>
            <v-expansion-panel-content v-for="(item,i) in articles" :key="i">
              <div slot="header"><h3>{{ item.name}}</h3></div>
              <v-card>
                <v-card-text v-html="item.text"></v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
    import vas from '@/lib/VASClient';
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                articles: null,
                stats: null,
                data: null,
                backgroundImage: require('../../../static/img/health_bg.png')
            }
        },
        methods: {
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        },
        computed: {
            ...mapState(
                ['auth']
            ),
        },
        mounted() {
            var self = this;

            Loading.show('');

            vas.corona().then(function (response) {
                window.corona = response;

                self.articles = response.articles;
                self.stats = response.stats;
                self.data = response.data;

                Loading.hide();
            });
        }
    }
</script>
<style>
  .text-center {
    text-align: center;
  }

  .number {
    font-size: 3em;
  }
</style>
